import './scss/bootstrap.scss';
import './scss/fontawesome.scss';
import './scss/spinao.scss';

import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
import "../assets-base/assets-src/js/bootstrap/Carousel";
import "../assets-base/assets-src/js/bootstrap/Dropdown";
import "../assets-base/assets-src/js/bootstrap/Button";
import "../assets-base/assets-src/js/bootstrap/Collapse";
import "../assets-base/assets-src/js/bootstrap/Tab";
import "../assets-base/assets-src/js/Spinao/CookieConsent";
import BSCustomFileInput from '../assets-base/assets-src/js/bootstrap/CustomFileUpload/index';
import * as StickyTopMenu from '../assets-base/assets-src/js/Spinao/StickyTopMenu';
import * as UnifyHeight from '../assets-base/assets-src/js/Spinao/UnifyHeight';
import * as BackToTop from '../assets-base/assets-src/js/Spinao/BackToTop';
import * as EUCookie from '../assets-base/assets-src/js/Spinao/EUCookie';
import * as GoogleMaps from '../assets-base/assets-src/js/Spinao/GoogleMaps';
import * as GoogleReCaptcha from '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';
import * as Offside from '../assets-base/assets-src/js/offside';
import * as NetteAjaxForm from '../assets-base/assets-src/js/Spinao/NetteAjaxForm';

document.addEventListener("DOMContentLoaded", function() {
    Offside.initialize('navbarCollapse', {
        buttonsSelector: '.js-offcanvas-trigger'
    });

    Lightgallery.applyTo('#js-lightgallery', {
        selector:'.js-lightgallery-image',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    StickyTopMenu.initialize();

    UnifyHeight.applyTo('.js-unify-height');

    BackToTop.applyTo('backtotop_js');

    EUCookie.initialize();

    NetteAjaxForm.initialize('[data-ajax="form"]');

    BSCustomFileInput.init();

    GoogleMaps.initialize();
    GoogleReCaptcha.initialize();
});
